import React from 'react'
import './footer.css'


function Footer() {
    return (
        <div className="footer">
            <h1>Book a ride for pleasure</h1>
            <p>to know details plese visit the our rides section</p>

        </div>
    )
}

export default Footer
